import type { IconName } from "@similarweb/icons";
import type { FC } from "react";
import { StyledComingSoonLabelWrapper, StyledLabelIcon, StyledLabelText } from "./styles";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

type ComingSoonLabelProps = {
    textKey: string;
    iconName: IconName;
};
const ComingSoonLabel: FC<ComingSoonLabelProps> = ({ textKey, iconName }) => {
    return (
        <StyledComingSoonLabelWrapper>
            <StyledLabelIcon iconName={iconName} />
            <I18n
                translatable={{ key: textKey }}
                element={StyledLabelText}
            />
        </StyledComingSoonLabelWrapper>
    );
};

export default ComingSoonLabel;
